// extracted by mini-css-extract-plugin
module.exports = {"block":"_1792","item":"_8879","value":"_2815"};